"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.LayoutAmenitiesDto = void 0;
var class_validator_1 = require("class-validator");
var LayoutAmenitiesDto = (function () {
    function LayoutAmenitiesDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], LayoutAmenitiesDto.prototype, "roomSize");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['SQUARE_METER', 'SQUARE_FEET']),
        __metadata("design:type", String)
    ], LayoutAmenitiesDto.prototype, "roomSizeUnit");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "separateDiningArea");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "separateSittingArea");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "sharedAccommodations");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "desk");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "laptopFriendlyWorkspace");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "fireplace");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "heatedFloors");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "accessViaExteriorCorridors");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "privatePool");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "privatePlungePool");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "privateSpaTub");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn([
            '',
            'BALCONY',
            'BALCONY_OR_PATIO',
            'DECK_OR_PATIO',
            'FURNISHED_BALCONY',
            'FURNISHED_BALCONY_OR_PATIO',
            'FURNISHED_LANAI',
            'LANAI',
            'PORCH_OR_LANAI',
            'PATIO',
        ]),
        __metadata("design:type", String)
    ], LayoutAmenitiesDto.prototype, "outdoorSpaces");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "individuallyDecorated");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "individuallyFurnished");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "connectingRoomsAvailable");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "yard");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "noWindows");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], LayoutAmenitiesDto.prototype, "inRoomPlaypen");
    return LayoutAmenitiesDto;
}());
exports.LayoutAmenitiesDto = LayoutAmenitiesDto;
//# sourceMappingURL=layout-amenities.dto.js.map